import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import Choice from '@/components/common/Choice.vue'
  import useIcons from '@/composables/useIcons'
  import RootFoldersApi from '@/services/api/RootFoldersApi'
  import type { RootFolder } from '@/services/interfaces/Folder'
  import type { Nullable } from '@/services/interfaces/Content'
  import type { SvgRendererProps } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'InterestedCategories',
  props: {
    header: String,
  },
  emits: ['selected-categories'],
  setup(__props, { emit }) {

  

  

  const { checkedCheckboxSquareWhite, checkboxSquareWhite } = useIcons()
  const interestedCategories = ref(null as Nullable<RootFolder[]>)
  const selectedRootFolders = ref([] as string[])

  const selectedRootFolderIcon = computed(() => {
    return (folderId: string): SvgRendererProps => {
      return selectedRootFolders.value.includes(folderId)
        ? { icon: checkedCheckboxSquareWhite.value, strokeColor: 'var(--primary-text-color)' }
        : { icon: checkboxSquareWhite.value, strokeColor: 'var(--primary-text-color)' }
    }
  })

  const onRootFolderClick = (folderId: string): void => {
    if (selectedRootFolders.value.includes(folderId)) {
      const index = selectedRootFolders.value.indexOf(folderId)
      selectedRootFolders.value.splice(index, 1)
    } else {
      selectedRootFolders.value.push(folderId)
    }
    emit('selected-categories', selectedRootFolders.value)
  }

  RootFoldersApi.interestedCategories().then((rootFolders) => {
    interestedCategories.value = rootFolders
    selectedRootFolders.value = rootFolders.filter((folder) => folder.selected).map((folder) => folder.id)
  })

return { __sfc: true,emit, checkedCheckboxSquareWhite, checkboxSquareWhite, interestedCategories, selectedRootFolders, selectedRootFolderIcon, onRootFolderClick, computed, ref, LoadingSpinner, Choice, useIcons, RootFoldersApi }
}

})